// Dev mode detection - only log in development
const isDevMode = true;

// Conditional logger - only logs in dev mode
const devLog = {
  log: function (...args) {
    if (isDevMode) console.log(...args);
  },
  warn: function (...args) {
    if (isDevMode) console.warn(...args);
  },
  error: function (...args) {
    // Always show errors, even in production
    console.error(...args);
  },
  time: function (...args) {
    if (isDevMode) console.time(...args);
  },
  timeEnd: function (...args) {
    if (isDevMode) console.timeEnd(...args);
  },
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    // Find the button element (in case event.target is an SVG icon inside the button)
    const button = event.target.closest("button") || event.target;
    const previousValue = this.input.value;

    // Check if it's plus or minus button
    if (button.name === "plus") {
      this.input.stepUp();
    } else if (button.name === "minus") {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    // Flag to track initialization state
    this.isInitializing = true;

    // Flag to track if we're in "SELECT A SIZE" mode
    this.isSelectSizeMode = false;

    // Initialize variant cache for performance optimization
    if (!window.variantCache) {
      window.variantCache = {
        variants: new Map(), // Store variants by ID
        optionCombinations: new Set(), // Track fetched combinations

        addVariants: function (variantArray) {
          variantArray.forEach((v) => this.variants.set(v.id, v));
          devLog.log(`💾 Cache: ${this.variants.size} total variants stored`);
        },

        getVariant: function (color, size) {
          for (let variant of this.variants.values()) {
            if (
              variant.options &&
              variant.options[0] === color &&
              variant.options[1] === size
            ) {
              return variant;
            }
          }
          return null;
        },

        getAllVariants: function () {
          return Array.from(this.variants.values());
        },

        hasCombination: function (optionValueIds) {
          const key = optionValueIds.sort().join(",");
          return this.optionCombinations.has(key);
        },

        markCombination: function (optionValueIds) {
          const key = optionValueIds.sort().join(",");
          this.optionCombinations.add(key);
        },
      };
      devLog.log("🚀 Variant cache initialized");
    }

    // Load initial variants into cache
    this.loadInitialVariants();
    // Check if we have a valid current variant (either from URL or default selection)
    const queryParams = new URLSearchParams(window.location.search);
    const variantQueryParam = queryParams.get("variant");

    this.updateOptions();
    this.updateMasterId();
    if (variantQueryParam) {
      // Variant in URL - update variant URL and button state
      this.updateVariantUrl();
      // Update price/availability (including pre-order button) on initial load
      if (this.currentVariant) {
        this.updatePriceAndAvailabilityFromVariant();
      }
      this.updateUrgencyAndNotifications();
    } else {
      this.displaySelectSizeText();
      // No variant in URL - check if we have a default variant selected
      if (this.currentVariant) {
        // Default variant selected - update button state for pre-order
        this.updatePriceAndAvailabilityFromVariant();
        this.updateUrgencyAndNotifications();
      }
    }

    this.addEventListener("change", this.onVariantChange);

    // Listen for cart operations that might affect variant state
    // this.setupCartEventListeners();

    // Mark initialization as complete and sync sticky selector
    setTimeout(() => {
      this.isInitializing = false;
      devLog.log("✅ Variant selector initialization complete");

      // Rebuild sticky dropdown with all initial variants
      this.rebuildStickyVariantOptions();

      // Sync sticky selector to match initial variant
      if (this.currentVariant) {
        this.updateStickyVariantSelector();
      }
    }, 100);

    // Setup sticky variant selector sync after a delay to avoid initial load conflicts
    setTimeout(() => {
      this.setupStickyVariantSync();
    }, 600);

    // Auto-prefetch preferred size variants based on Liquid config
    this.autoPrefetchFromConfig();
  }

  setupCartEventListeners() {
    // Rebuy event listeners removed - using native cart
    // Listen for native cart drawer open/close events if needed
    // Note: Native cart drawer may have different event names

    // Listen for successful cart add
    document.addEventListener("cart:item-added", () => {
      devLog.log("✅ Item added to cart - restoring button state");
      setTimeout(() => this.restoreButtonState(), 600);
    });
  }

  setupStickyVariantSync() {
    const stickySelect = document.querySelector(
      '[data-variant-select="sticky"]',
    );

    if (!stickySelect) {
      devLog.log("ℹ️ Sticky variant selector not found - sync not needed");
      return;
    }

    devLog.log("✅ Setting up sticky variant selector sync");

    // Flags to prevent infinite loop and ignore initial events
    this.isUpdatingFromSticky = false;
    this.stickyInitComplete = false;

    // Wait a moment before marking sticky init as complete to ignore initial change events
    setTimeout(() => {
      this.stickyInitComplete = true;
      devLog.log("✅ Sticky selector sync fully initialized");
    }, 200);

    // Listen for changes on sticky selector
    stickySelect.addEventListener("change", (event) => {
      // Ignore events during sticky initialization
      if (!this.stickyInitComplete) {
        devLog.log("🔄 Ignoring sticky change (sticky still initializing)");
        return;
      }

      // Prevent infinite loop - ignore if we're already updating
      if (this.isUpdatingFromSticky) {
        devLog.log("🔄 Ignoring sticky change (already updating)");
        return;
      }

      const selectedVariantId = event.target.value;
      devLog.log(
        "📍 Sticky selector changed to variant ID:",
        selectedVariantId,
      );

      // Find and trigger the corresponding option in the main variant picker
      const variantData = this.getVariantData();
      const selectedVariant = variantData.find(
        (v) => v.id == selectedVariantId,
      );

      if (!selectedVariant) {
        console.warn("⚠️ Selected variant not found in variant data");
        return;
      }

      devLog.log("🎯 Syncing main picker to:", selectedVariant.title);

      // Set flag to prevent loop
      this.isUpdatingFromSticky = true;

      // Update main variant picker radio buttons
      const colorRadio = this.querySelector(
        `input[type="radio"][name="Color"][value="${selectedVariant.option1}"], input[type="radio"][name="Colour"][value="${selectedVariant.option1}"]`,
      );
      const sizeRadio = this.querySelector(
        `input[type="radio"][name="Size"][value="${selectedVariant.option2}"]`,
      );

      if (colorRadio) {
        colorRadio.checked = true;
        devLog.log("✅ Color radio updated:", selectedVariant.option1);
      }

      if (sizeRadio) {
        sizeRadio.checked = true;
        devLog.log("✅ Size radio updated:", selectedVariant.option2);
      }

      // Trigger variant change
      this.dispatchEvent(new Event("change", { bubbles: true }));

      // Reset flag after a short delay to allow the update to complete
      setTimeout(() => {
        this.isUpdatingFromSticky = false;
        devLog.log("✅ Sticky update flag reset");
      }, 100);
    });
  }

  // Helper method to check if we're in SELECT A SIZE mode
  // Checks both the flag and whether a size radio is actually checked
  isInSelectSizeMode() {
    // First check the flag
    if (this.isSelectSizeMode === true) {
      return true;
    }
    // Also check if no size radio is actually checked
    const sizeInputs = document.querySelectorAll(
      'input[type="radio"][name="Size"]',
    );
    if (sizeInputs.length > 0) {
      const checkedSizeInput = Array.from(sizeInputs).find(
        (input) => input.checked,
      );
      // If no size is checked, we're effectively in SELECT A SIZE mode
      return !checkedSizeInput;
    }
    return false;
  }

  restoreButtonState() {
    devLog.log("🔄 Restoring button state");
    if (!this.currentVariant) {
      console.warn("⚠️ No current variant to restore state for");
      return;
    }

    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) {
      console.warn("⚠️ Product form not found");
      return;
    }

    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) {
      console.warn("⚠️ Add button not found in product form");
      return;
    }

    // Clean up any leftover states from form submission
    addButton.classList.remove("loading");
    addButton.removeAttribute("aria-disabled");

    const spinner = productForm.querySelector(".loading-overlay__spinner");
    if (spinner) {
      spinner.classList.add("hidden");
    }

    // Restore button based on current variant availability
    if (this.currentVariant.available) {
      devLog.log("✅ Restoring enabled state for available variant");
      this.toggleAddButton(false, "", false);
    } else {
      // Don't show sold out if we're in SELECT A SIZE mode
      if (this.isInSelectSizeMode()) {
        devLog.log("🎯 SELECT A SIZE mode: Not showing sold out");
        this.toggleAddButton(false, "", false);
      } else {
        devLog.log("❌ Restoring disabled state for sold out variant");
        this.toggleAddButton(
          true,
          window.variantStrings?.soldOut || "Sold out",
          false,
        );
      }
    }
  }

  // Removed showLoading() and hideLoading() - now using toggleAddButton() directly

  onVariantChange() {
    devLog.log("🔄 Variant change initiated");
    console.time("totalTime");

    // 🚀 FAST: Update media FIRST based on selected color (instant visual feedback)
    // This runs BEFORE "Hold tight..." so user sees color change immediately
    const selectedColor = this.getSelectedColorValue();
    if (selectedColor) {
      devLog.log("🎨 Selected color detected:", selectedColor);
      this.updateMediaByColor(selectedColor);
    }

    // Skip loading state during initialization to prevent button state issues
    if (!this.isInitializing) {
      // Show "Hold tight..." message while checking variant
      this.toggleAddButton(
        true,
        "Hold tight... we are looking for your size",
        false,
      );
    } else {
      devLog.log("ℹ️ Skipping loading state (still initializing)");
    }

    console.time("updateOptions");
    this.updateOptions();
    devLog.log("📋 Updated options:", this.options);
    console.timeEnd("updateOptions");

    // Safeguard: If we're in SELECT A SIZE mode, verify no size radio is actually checked
    // If a size radio is checked, exit SELECT A SIZE mode
    if (this.isSelectSizeMode) {
      const sizeInputs = document.querySelectorAll(
        'input[type="radio"][name="Size"]',
      );
      const checkedSizeInput = Array.from(sizeInputs).find(
        (input) => input.checked,
      );
      if (checkedSizeInput) {
        devLog.log("✅ Size radio is checked - exiting SELECT A SIZE mode");
        this.isSelectSizeMode = false;
      } else {
        devLog.log("🎯 SELECT A SIZE mode preserved - no size radio checked");
      }
    }

    console.time("updateMasterId");
    this.updateMasterId();
    devLog.log("🎯 Current variant:", this.currentVariant);
    console.timeEnd("updateMasterId");

    // Product data is no longer needed - we use variant data directly

    console.time("updatePickupAvailability");
    this.updatePickupAvailability();
    console.timeEnd("updatePickupAvailability");

    console.time("removeErrorMessage");
    this.removeErrorMessage();
    console.timeEnd("removeErrorMessage");

    // Check if variant exists in current data (new API limitation)
    if (!this.currentVariant) {
      console.warn(
        "⚠️ Variant not in current JSON data - need to fetch with Section Rendering API",
      );

      // Get selected option value IDs for Section Rendering API
      const selectedOptionValueIds = this.getSelectedOptionValueIds();

      if (selectedOptionValueIds.length > 0) {
        devLog.log(
          "🔄 Fetching section with option values:",
          selectedOptionValueIds,
        );
        this.fetchSectionWithOptions(selectedOptionValueIds);
        return; // Exit early, fetchSectionWithOptions will handle the update
      }

      console.warn("⚠️ No option value IDs found");
      console.time("setUnavailable");
      this.setUnavailable();
      console.timeEnd("setUnavailable");
    } else {
      devLog.log("✅ Variant found in current data, updating UI components");

      console.time("updateVariantUrl");
      this.updateVariantUrl();
      console.timeEnd("updateVariantUrl");

      // 🚀 FAST PATH: Update price/availability directly from variant data (NO API CALL!)
      this.updatePriceAndAvailabilityFromVariant();

      console.time("updateMedia");
      this.updateMedia();
      devLog.log("🖼️ Media updated for variant:", this.currentVariant.id);
      console.timeEnd("updateMedia");

      console.time("updateURL");
      this.updateURL();
      devLog.log("🔗 URL updated to:", window.location.href);
      console.timeEnd("updateURL");

      console.time("updateVariantInput");
      this.updateVariantInput();
      devLog.log("📝 Variant input updated to:", this.currentVariant.id);
      console.timeEnd("updateVariantInput");

      console.time("updateShareUrl");
      this.updateShareUrl();
      console.timeEnd("updateShareUrl");

      console.time("updateStickyVariantSelector");
      this.updateStickyVariantSelector();
      console.timeEnd("updateStickyVariantSelector");

      // Verify form state after all updates
      this.verifyFormState();

      console.timeEnd("totalTime");
      devLog.log("⚡ FAST PATH - NO API CALL!");
    }
  }

  verifyFormState() {
    devLog.log("🔍 Verifying form state after variant change");
    const allForms = document.querySelectorAll('form[action*="/cart/add"]');
    devLog.log("📋 Total forms found:", allForms.length);

    let needsForceUpdate = false;

    allForms.forEach((form, index) => {
      const variantInput = form.querySelector('input[name="id"]');
      const addButton = form.querySelector('[name="add"]');

      devLog.log(`📋 Form ${index + 1}:`);
      devLog.log(
        `   - Variant ID: ${variantInput ? variantInput.value : "not found"}`,
      );
      devLog.log(`   - Expected ID: ${this.currentVariant.id}`);
      const isMatch =
        variantInput && variantInput.value == this.currentVariant.id;
      devLog.log(`   - Match: ${isMatch ? "✅" : "❌"}`);
      devLog.log(
        `   - Add button disabled: ${
          addButton ? addButton.disabled : "not found"
        }`,
      );

      if (!isMatch && variantInput) {
        needsForceUpdate = true;
        devLog.log(`⚠️ Form ${index + 1} needs force update`);
      }
    });

    // Force update if needed
    if (needsForceUpdate) {
      devLog.log("🔄 Force updating variant inputs");
      setTimeout(() => {
        this.forceUpdateVariantInputs();
      }, 100);
    }
  }

  forceUpdateVariantInputs() {
    devLog.log("🔄 Force updating all variant inputs");
    const allForms = document.querySelectorAll('form[action*="/cart/add"]');

    allForms.forEach((form, index) => {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        devLog.log(
          `🔄 Force updating form ${index + 1} from ${variantInput.value} to ${
            this.currentVariant.id
          }`,
        );
        variantInput.value = this.currentVariant.id;
        variantInput.dispatchEvent(new Event("change", { bubbles: true }));
        variantInput.dispatchEvent(new Event("input", { bubbles: true }));
        devLog.log(`✅ Form ${index + 1} force updated`);
      }
    });
  }

  // Get the currently selected color value directly from radio buttons
  // This doesn't require currentVariant to be set
  getSelectedColorValue() {
    // Try to find checked color/colour radio button
    const colorInput = this.querySelector(
      'input[type="radio"][name="Color"]:checked, input[type="radio"][name="Colour"]:checked',
    );
    if (colorInput) {
      return colorInput.value.toUpperCase();
    }
    return null;
  }

  // Get the currently selected size value directly from radio buttons
  getSelectedSizeValue() {
    const sizeInput = this.querySelector(
      'input[type="radio"][name="Size"]:checked',
    );
    if (sizeInput) {
      return sizeInput.value;
    }
    return null;
  }

  // Update media/images immediately based on selected color
  // This runs BEFORE full variant data is loaded for instant visual feedback
  updateMediaByColor(color) {
    if (!color) return;

    console.log("🖼️ [global] updateMediaByColor called with color:", color);
    devLog.log("🖼️ FAST: Updating media immediately for color:", color);
    console.time("updateMediaByColor");

    try {
      // 🚀 SKIP if current active media already matches this color
      // This prevents flicker from multiple calls (e.g., sticky selector sync)
      const mediaGallery = document.querySelector("media-gallery");
      console.log("🖼️ [global] mediaGallery:", mediaGallery ? "found" : "NOT FOUND");
      if (mediaGallery) {
        const currentActiveMedia = mediaGallery.querySelector(
          "[data-media-id].is-active",
        );
        if (currentActiveMedia) {
          const activeMediaAlt =
            currentActiveMedia.getAttribute("data-thumb-alt") || "";
          console.log("🖼️ [global] Current active media alt:", activeMediaAlt, "| color match:", activeMediaAlt.toUpperCase().includes(color));
          if (activeMediaAlt.toUpperCase().includes(color)) {
            console.log("🖼️ [global] SKIPPING - active media already matches color");
            devLog.log(
              "🖼️ SKIP updateMediaByColor: Active media already matches color:",
              color,
            );
            console.timeEnd("updateMediaByColor");
            return; // Skip - already showing correct color
          }
        }
      }

      // 🎯 Try to find the exact variant's featured media from cache (color + size)
      let targetMediaId = null;
      const selectedSize = this.getSelectedSizeValue();
      console.log("🖼️ [global] selectedSize:", selectedSize);

      if (selectedSize && window.variantCache) {
        const cachedVariant = window.variantCache.getVariant(
          color,
          selectedSize,
        );
        console.log("🖼️ [global] cachedVariant:", cachedVariant ? "found" : "NOT FOUND", cachedVariant?.featured_media ? "has featured_media" : "no featured_media");
        if (cachedVariant && cachedVariant.featured_media) {
          targetMediaId = `${this.dataset.section}-${cachedVariant.featured_media.id}`;
          devLog.log("🎯 Found cached variant featured media:", targetMediaId);
        }
      }

      const thumbImagesColor = document.querySelectorAll("[data-color-alt]");
      const mainImagesColor = document.querySelectorAll("[data-thumb-alt]");

      console.log("🖼️ [global] thumbImagesColor count:", thumbImagesColor.length);
      console.log("🖼️ [global] mainImagesColor count:", mainImagesColor.length);
      devLog.log("🖼️ Thumbnail images found:", thumbImagesColor.length);
      devLog.log("🖼️ Main images found:", mainImagesColor.length);

      let thumbMoved = 0;
      let mainMoved = 0;
      let firstMediaId = null;

      // Reorder thumbnail images by color
      thumbImagesColor.forEach((swatch) => {
        try {
          const imageColors = swatch.getAttribute("data-color-alt");
          const swatchItem = swatch.closest("li");
          if (imageColors && imageColors.includes(color)) {
            const thumbnailList = document.querySelector(".thumbnail-list");
            if (thumbnailList && swatchItem) {
              thumbnailList.prepend(swatchItem);
              thumbMoved++;
              // Capture fallback media ID (first image of this color)
              if (!firstMediaId && swatchItem.dataset.target) {
                firstMediaId = swatchItem.dataset.target;
              }
            }
          }
        } catch (error) {
          console.warn("⚠️ Error processing thumbnail image:", error);
        }
      });

      // Reorder main images by color
      mainImagesColor.forEach((swatch) => {
        try {
          const imageColors = swatch.getAttribute("data-thumb-alt");
          if (imageColors && imageColors.includes(color)) {
            const mediaList = document.querySelector(
              ".product__media-list.slider--mobile",
            );
            if (mediaList) {
              mediaList.prepend(swatch);
              mainMoved++;
              // Fallback: get media ID from main images if not found from thumbnails
              if (!firstMediaId && swatch.dataset.mediaId) {
                firstMediaId = swatch.dataset.mediaId;
              }
            }
          }
        } catch (error) {
          console.warn("⚠️ Error processing main image:", error);
        }
      });

      console.log(`🖼️ [global] Moved ${thumbMoved} thumbnails and ${mainMoved} main images`);
      devLog.log(
        `🖼️ FAST: Moved ${thumbMoved} thumbnail images and ${mainMoved} main images`,
      );

      // 🚀 INSTANT VISUAL UPDATE: Call setActiveMedia with prepend=true
      // This matches what main-product.liquid does on initial load:
      // prepend=true triggers resetPages() inside the media gallery,
      // ensuring the slider recalculates after our DOM reordering above.
      // The active element is already first from our prepend loop, so
      // the extra prepend inside setActiveMedia is a harmless no-op.
      const mediaIdToSet = targetMediaId || firstMediaId;
      console.log("🖼️ [global] mediaIdToSet:", mediaIdToSet, "| targetMediaId:", targetMediaId, "| firstMediaId:", firstMediaId);

      if (
        mediaIdToSet &&
        mediaGallery &&
        typeof mediaGallery.setActiveMedia === "function"
      ) {
        devLog.log("🖼️ FAST: Setting active media to:", mediaIdToSet);
        devLog.log(
          "🖼️ (using cached variant:",
          !!targetMediaId,
          ", fallback:",
          !targetMediaId,
          ")",
        );
        mediaGallery.setActiveMedia(mediaIdToSet, true);
        console.log("🖼️ [global] setActiveMedia called with prepend=true");
        devLog.log("🖼️ FAST: setActiveMedia called successfully");
      } else {
        console.log("🖼️ [global] SKIPPED setActiveMedia - mediaIdToSet:", mediaIdToSet, "mediaGallery:", !!mediaGallery, "hasMethod:", typeof mediaGallery?.setActiveMedia);
      }

      console.timeEnd("updateMediaByColor");
    } catch (error) {
      console.warn("⚠️ Error in updateMediaByColor:", error);
    }
  }

  updateOptions() {
    devLog.log("🔍 Updating options from select elements");
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
    devLog.log("📋 Options array:", this.options);
  }

  updateMasterId() {
    devLog.log("🎯 Finding current variant based on options");
    const variantData = this.getVariantData();
    devLog.log("📊 Total variants available:", variantData.length);
    devLog.log("🔍 Searching for variant with options:", this.options);
    devLog.log("🔍 Variant data:", variantData);
    devLog.log("🔍 Options:", this.options);

    if (!variantData || variantData.length === 0) {
      console.error("❌ No variant data available!");
      this.currentVariant = null;
      return;
    }

    this.currentVariant = variantData.find((variant) => {
      const match =
        variant.options[0] === this.options[0] &&
        variant.options[1] === this.options[1];
      if (match) {
        devLog.log("✅ Found matching variant:", variant);
      }
      return match;
    });

    if (!this.currentVariant) {
      console.warn("❌ No matching variant found for options:", this.options);
      devLog.log("🔍 Available option combinations:");
      variantData.slice(0, 5).forEach((variant, index) => {
        devLog.log(
          `   ${index + 1}. ${variant.options[0]} / ${variant.options[1]}`,
        );
      });
    }
  }

  updateMedia() {
    try {
      devLog.log("🖼️ Updating media for variant (setActiveMedia only)");
      if (!this.currentVariant) {
        console.warn("⚠️ No current variant for media update");
        return;
      }
      if (!this.currentVariant.featured_media) {
        console.warn("⚠️ No featured media for current variant");
        return;
      }

      // NOTE: Image reordering by color is now done FIRST in onVariantChange()
      // via updateMediaByColor() for instant visual feedback.
      // This method now only handles setActiveMedia() which requires variant data.

      const mediaGallery = document.getElementById(
        `MediaGallery-${this.dataset.section}`,
      );
      devLog.log(
        "🖼️ Media gallery element:",
        mediaGallery ? "found" : "not found",
      );

      if (mediaGallery && typeof mediaGallery.setActiveMedia === "function") {
        try {
          const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;

          // 🚀 SKIP if current active media is already the EXACT same media
          // This prevents flicker when updateMediaByColor() already set the correct image
          const currentActiveMedia = mediaGallery.querySelector(
            "[data-media-id].is-active",
          );
          if (currentActiveMedia) {
            const activeMediaId =
              currentActiveMedia.getAttribute("data-media-id");
            if (activeMediaId === mediaId) {
              devLog.log(
                "🖼️ SKIP: Active media already matches exact ID:",
                mediaId,
              );
              devLog.log("✅ Keeping preloaded image to prevent flicker");
              return; // Skip setActiveMedia - already showing correct image
            }
          }

          devLog.log("this.dataset.section ", this.dataset.section);
          devLog.log(
            "this.currentVariant.featured_media.id ",
            this.currentVariant.featured_media.id,
          );
          devLog.log(
            "this.currentVariant.featured_media ",
            this.currentVariant.featured_media,
          );
          devLog.log("🎯 Setting active media:", mediaId);
          // Use prepend=false since updateMediaByColor() already reordered images
          mediaGallery.setActiveMedia(mediaId, false);
          devLog.log("✅ Media gallery setActiveMedia called successfully");
        } catch (error) {
          console.warn("⚠️ Error calling setActiveMedia:", error);
        }
      } else {
        console.warn("⚠️ Media gallery or setActiveMedia method not available");
      }

      // Update modal content
      try {
        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`,
        );
        if (modalContent) {
          const newMediaModal = modalContent.querySelector(
            `[data-media-id="${this.currentVariant.featured_media.id}"]`,
          );
          if (newMediaModal) {
            modalContent.prepend(newMediaModal);
            devLog.log("✅ Modal media reordered");
          } else {
            console.warn("⚠️ Modal media element not found");
          }
        } else {
          console.warn("⚠️ Modal content not found");
        }
      } catch (error) {
        console.warn("⚠️ Error updating modal content:", error);
      }

      devLog.log("✅ Media update completed successfully");
    } catch (error) {
      console.error("❌ Critical error in updateMedia:", error);
      devLog.log(
        "🔄 Continuing with other variant updates despite media error",
      );
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateStickyVariantSelector() {
    if (!this.currentVariant) return;

    // Skip if we're updating from sticky selector (prevent loop)
    if (this.isUpdatingFromSticky) {
      devLog.log(
        "🔄 Skipping sticky selector update (already updating from sticky)",
      );
      return;
    }

    devLog.log("🔄 Updating sticky variant selector");
    const stickySelect = document.querySelector(
      '[data-variant-select="sticky"]',
    );

    if (!stickySelect) {
      devLog.log(
        "ℹ️ Sticky variant selector not found (may not be on this page)",
      );
      return;
    }

    // Update the selected option to match current variant
    const currentVariantId = this.currentVariant.id;
    devLog.log("🎯 Setting sticky selector to variant ID:", currentVariantId);

    // Find and select the option with matching variant ID
    const options = stickySelect.querySelectorAll("option");
    let optionFound = false;

    options.forEach((option) => {
      if (option.value == currentVariantId) {
        option.selected = true;
        optionFound = true;
        devLog.log("✅ Sticky selector updated to:", option.textContent.trim());
      } else {
        option.selected = false;
      }
    });

    if (!optionFound) {
      console.warn(
        "⚠️ Current variant not found in sticky selector options - may need to rebuild options",
      );
    }

    // Don't dispatch change event - we're just syncing the UI
    // (dispatching would trigger the sticky selector listener and create a loop)
  }

  rebuildStickyVariantOptions() {
    devLog.log("🔄 Rebuilding sticky variant selector options");
    const stickySelect = document.querySelector(
      '[data-variant-select="sticky"]',
    );

    if (!stickySelect) {
      devLog.log("ℹ️ Sticky variant selector not found");
      return;
    }

    // Get all variants from cache
    const allVariants = this.getVariantData();
    devLog.log(
      `📦 Rebuilding sticky dropdown with ${allVariants.length} variants`,
    );

    // Store current selection
    const currentValue = stickySelect.value;

    // Clear existing options
    stickySelect.innerHTML = "";

    // Sort variants by color (option1) first, then by size (option2)
    const sortedVariants = allVariants.sort((a, b) => {
      // First sort by color
      const colorA = a.option1 || a.options?.[0] || "";
      const colorB = b.option1 || b.options?.[0] || "";

      if (colorA !== colorB) {
        return colorA.localeCompare(colorB);
      }

      // If same color, sort by size
      const sizeA = a.option2 || a.options?.[1] || "";
      const sizeB = b.option2 || b.options?.[1] || "";

      // Try to sort numerically if sizes are numbers
      const numA = parseInt(sizeA);
      const numB = parseInt(sizeB);

      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      }

      // Otherwise sort alphabetically
      return sizeA.localeCompare(sizeB);
    });

    devLog.log(`🎨 Sorted ${sortedVariants.length} variants by color and size`);

    // Add sorted variants to dropdown
    sortedVariants.forEach((variant) => {
      const option = document.createElement("option");
      option.value = variant.id;

      // Build option text from variant title
      option.textContent = variant.title;

      // Disable if not available
      if (!variant.available) {
        option.disabled = true;
      }

      // Select if it matches current variant
      if (variant.id == this.currentVariant?.id || variant.id == currentValue) {
        option.selected = true;
      }

      stickySelect.appendChild(option);
    });

    devLog.log(
      `✅ Sticky dropdown rebuilt with ${stickySelect.options.length} options (sorted by color)`,
    );
  }

  updateVariantInput() {
    devLog.log("📝 Updating variant input fields");
    devLog.log("📝 Current variant ID:", this.currentVariant.id);
    devLog.log("📝 Section ID:", this.dataset.section);

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    devLog.log("📋 Found product forms:", productForms.length);

    if (productForms.length === 0) {
      console.warn(
        "⚠️ No product forms found with selectors:",
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
      );
      // Try alternative selectors
      const alternativeForms = document.querySelectorAll(
        'form[action*="/cart/add"]',
      );
      devLog.log("📋 Alternative forms found:", alternativeForms.length);

      alternativeForms.forEach((productForm, index) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
          devLog.log(
            `📝 Alternative Form ${index + 1}: Updating variant ID from ${
              input.value
            } to ${this.currentVariant.id}`,
          );
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
          devLog.log(
            `✅ Alternative Form ${
              index + 1
            }: Variant input updated and change event dispatched`,
          );
        } else {
          console.warn(
            `⚠️ Alternative Form ${index + 1}: No variant input found`,
          );
        }
      });
      return;
    }

    productForms.forEach((productForm, index) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        devLog.log(
          `📝 Form ${index + 1}: Updating variant ID from ${input.value} to ${
            this.currentVariant.id
          }`,
        );
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
        devLog.log(
          `✅ Form ${
            index + 1
          }: Variant input updated and change event dispatched`,
        );
      } else {
        console.warn(`⚠️ Form ${index + 1}: No variant input found`);
        // Log the form HTML to debug
        devLog.log(`📝 Form ${index + 1} HTML:`, productForm.innerHTML);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    devLog.log("🔄 Rendering product info for variant:", requestedVariantId);

    const fetchUrl = `${
      this.dataset.url
    }?variant=${requestedVariantId}&section_id=${
      this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
    }`;
    devLog.log("🌐 Fetching from URL:", fetchUrl);

    fetch(fetchUrl)
      .then((response) => {
        devLog.log("📡 Fetch response status:", response.status);
        return response.text();
      })
      .then((responseText) => {
        devLog.log("📄 Response text length:", responseText.length);

        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) {
          console.warn("⚠️ Variant changed during fetch, aborting update");
          return;
        }

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.querySelectorAll(
          `[data-current-price="price-${this.dataset.section}"]`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const currentPrice = document.querySelectorAll(
          `[data-current-price="price-${this.dataset.section}"]`,
        );

        devLog.log(
          "💰 Price elements found - destination:",
          destination.length,
          "source:",
          source ? "found" : "not found",
        );

        if (source && destination.length) {
          devLog.log("✅ Updating price elements");
          destination.forEach((el, index) => {
            devLog.log(`💰 Updating price element ${index + 1}`);
            el.innerHTML = source.innerHTML;
          });
        } else {
          console.warn(
            "⚠️ Price update skipped - missing source or destination elements",
          );
        }

        if (currentPrice.length) {
          devLog.log("👁️ Making price elements visible");
          currentPrice.forEach((elem, index) => {
            elem.classList.remove("visibility-hidden");
            devLog.log(`👁️ Made price element ${index + 1} visible`);
          });
        }

        devLog.log(
          "🔘 Toggling add button based on availability:",
          !this.currentVariant.available,
        );
        // Don't show sold out if we're in SELECT A SIZE mode
        if (this.isInSelectSizeMode() && !this.currentVariant.available) {
          devLog.log("🎯 SELECT A SIZE mode: Not showing sold out");
          this.toggleAddButton(false, "", false);
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut,
          );
        }
        console.timeEnd("totalTime");
        console.timeEnd("renderProductInfo");
        devLog.log("✅ Product info rendering completed");
      })
      .catch((error) => {
        console.error("❌ Error fetching product info:", error);
        this.setUnavailable();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    devLog.log("🔘 Toggling add button state");
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) {
      console.warn("⚠️ Product form not found");
      // Try alternative form selector
      const alternativeForm = document.querySelector(
        'form[action*="/cart/add"]',
      );
      if (alternativeForm) {
        devLog.log("✅ Found alternative form");
        this.toggleAddButtonOnForm(alternativeForm, disable, text, modifyClass);
      }
      return;
    }

    this.toggleAddButtonOnForm(productForm, disable, text, modifyClass);
  }

  toggleAddButtonOnForm(productForm, disable, text, modifyClass) {
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector(
      '[name="add"] > span:not(.loading-text)',
    );
    const loadingText = productForm.querySelector('[name="add"] .loading-text');

    if (!addButton) {
      console.warn("⚠️ Add button not found");
      return;
    }

    // Log current form state
    const variantInput = productForm.querySelector('input[name="id"]');
    devLog.log(
      `🔘 Form variant ID: ${variantInput ? variantInput.value : "not found"}`,
    );
    devLog.log(
      `🔘 Current button state - disabled: ${addButton.disabled}, text: "${addButtonText?.textContent}"`,
    );
    devLog.log(`🔘 New state - disable: ${disable}, text: "${text}"`);

    if (disable == false) {
      devLog.log("✅ Enabling add button");

      // First hide loading text IMMEDIATELY
      if (loadingText) {
        loadingText.style.display = "none";
        loadingText.classList.add("hidden");
      }

      // Then show and update main button text
      // Use custom text if provided (e.g., "Pre-order"), otherwise use default "Add to Cart"
      const buttonText =
        text && text.trim() !== ""
          ? text
          : window.variantStrings?.addToCart || "Add to cart";
      if (addButtonText) {
        addButtonText.style.display = "inline-block";
        addButtonText.classList.remove("hidden");
        addButtonText.textContent = buttonText;
      }

      // Finally enable button
      addButton.removeAttribute("disabled");

      if (document.querySelector(".afterpay_fake_btn")) {
        document
          .querySelector(".afterpay_fake_btn")
          .classList.remove("afterpay-disabled");
        devLog.log("✅ Afterpay button enabled");
      }
      devLog.log("✅ Button text set to:", buttonText);
    } else {
      // Disabling button - show "Hold tight..." or custom text
      devLog.log("⏳ Disabling add button");
      addButton.setAttribute("disabled", "disabled");

      // Use loading text for "Hold tight..." message, or main text for sold out
      if (!text || text === "Hold tight... we are looking for your size") {
        // First hide main button text
        if (addButtonText) {
          addButtonText.style.display = "none";
          addButtonText.classList.add("hidden");
        }

        // Then show loading message
        if (loadingText) {
          loadingText.style.display = "inline-block";
          loadingText.classList.remove("hidden");
          devLog.log("⏳ Showing loading text");
        }
      } else {
        // Show custom text (e.g., "Sold out", "Out of Stock")
        // First hide loading text
        if (loadingText) {
          loadingText.style.display = "none";
          loadingText.classList.add("hidden");
        }

        // Then show main text with custom message
        if (addButtonText) {
          addButtonText.style.display = "inline-block";
          addButtonText.classList.remove("hidden");
          addButtonText.textContent = text;
          devLog.log("📝 Button text set to:", text);
        }
      }

      setTimeout(function () {
        if (
          document.querySelector(".product-form__buttons .product-form__submit")
            ?.disabled
        ) {
          if (document.querySelector(".afterpay_fake_btn")) {
            document
              .querySelector(".afterpay_fake_btn")
              .classList.add("afterpay-disabled");
            devLog.log("⚠️ Afterpay button disabled");
          }
        }
      }, 1500);
      devLog.log("❌ Add button disabled");
    }

    if (!modifyClass) return;
  }

  updateVariantUrl() {
    devLog.log("🔗 Updating variant URLs");

    // Safety check: currentVariant must exist
    if (!this.currentVariant) {
      console.error(
        "⚠️ Cannot update variant URL - currentVariant is undefined",
      );
      return;
    }

    // Check if currentVariant exists before accessing its properties
    let currentVariantSize = null;
    if (this.currentVariant && this.currentVariant.options) {
      // Check if options[1] exists and is not null
      currentVariantSize =
        this.currentVariant.options[1] !== undefined &&
        this.currentVariant.options[1] !== null
          ? this.currentVariant.options[1]
          : this.currentVariant.options[0] || null;

      devLog.log("📏 Current variant size:", currentVariantSize);
    } else {
      console.error(
        "Current variant or its options are undefined",
        this.currentVariant,
      );
      return;
    }

    let availableVariants = [];
    // MULTI-COLOR PRODUCT: All colors are variants on the same product
    // Build availableVariants from the product's own variant data
    const isEffectivelySoldOut =
      this.currentVariant &&
      (!this.currentVariant.available ||
        (this.currentVariant.inventory_quantity <= 0 &&
          (this.currentVariant.inventory_policy || "").includes("continue")));

    if (isEffectivelySoldOut) {
      devLog.log(
        "🔍 Multi-color product: Finding available alternatives for sold out variant",
      );

      // Get product handle from dataset URL (e.g., /products/product-handle)
      const productUrl = this.dataset.url || "";
      devLog.log("🔍 Product URL:", productUrl);
      const handleMatch = productUrl.match(/\/products\/([^?]+)/);
      devLog.log("🔍 Handle match:", handleMatch);
      const productHandle = handleMatch ? handleMatch[1] : "";
      devLog.log("🔍 Product handle:", productHandle);
      if (!productHandle) {
        console.warn("⚠️ Could not extract product handle from dataset URL");
      } else {
        const variantData = this.getVariantData();
        devLog.log("🔍 Variant data:", variantData);

        // Get all variants with the same size but available (from the SAME product)
        variantData.forEach((variant, idx) => {
          devLog.log(
            `[LOG] Checking variant idx=${idx}, id=${variant.id}, available=${variant.available}, options=`,
            variant.options,
          );
          const variantEffectivelyAvailable =
            variant.available === true &&
            !(
              variant.inventory_quantity <= 0 &&
              (variant.inventory_policy || "").includes("continue")
            );
          if (
            variantEffectivelyAvailable &&
            variant.options &&
            variant.options[1] === currentVariantSize
          ) {
            if (availableVariants.length < 2) {
              const fullUrl = `/products/${productHandle}?variant=${variant.id}`;
              availableVariants.push({
                url: fullUrl,
                colour: variant.options[0], // Color is typically option1
                handle: productHandle,
              });
              devLog.log(
                `✅ Found alternative: ${variant.options[0]} in size ${currentVariantSize}, url: ${fullUrl}`,
              );
            } else {
              devLog.log(
                `[LOG] Skipping variant id=${variant.id} because 2 options already collected`,
              );
            }
          } else {
            if (!variant.available) {
              devLog.log(`[LOG] Variant id=${variant.id} is not available`);
            }
            if (
              !(variant.options && variant.options[1] === currentVariantSize)
            ) {
              devLog.log(
                `[LOG] Variant id=${variant.id} does not match size (${variant.options ? variant.options[1] : "undefined"} vs ${currentVariantSize})`,
              );
            }
          }
        });

        devLog.log(
          `📋 Found ${availableVariants.length} available alternatives:`,
          availableVariants,
        );
      }
    }

    if (isEffectivelySoldOut) {
      devLog.log("this.currentVariant", this.currentVariant);
      devLog.log("this.isInSelectSizeMode()", this.isInSelectSizeMode());
      // Don't show sold out message if we're in SELECT A SIZE mode
      if (this.isInSelectSizeMode()) {
        const soldOutText = document.querySelector(
          ".product__info-container-text-sold-out-text",
        );
        if (soldOutText) {
          soldOutText.innerHTML = "";
        }
        devLog.log("🎯 SELECT A SIZE mode: Not showing sold out message");
      } else if (availableVariants.length > 0) {
        const soldOutText = document.querySelector(
          ".product__info-container-text-sold-out-text",
        );
        if (soldOutText) {
          // Normalize colours (capitalize each word)
          availableVariants.forEach((variant) => {
            const words = variant.colour.toLowerCase().split(" ");
            const capitalizedWords = words.map(
              (word) => word.charAt(0).toUpperCase() + word.slice(1),
            );
            variant.colour = capitalizedWords.join(" ");
          });
          devLog.log("availableVariants", availableVariants);
          if (availableVariants.length === 2) {
            soldOutText.innerHTML = `
            ⚠️ Sold out for this colour, try
          <span id="alt-colour-1">
              <a class="alt-variant-url" href="${availableVariants[0].url}">${availableVariants[0].colour}</a>
          </span>
          or
          <span id="alt-colour-2">
          <a class="alt-variant-url" href="${availableVariants[1].url}">${availableVariants[1].colour}</a>
          </span>
          ⚠️
      `;
          } else if (availableVariants.length === 1) {
            soldOutText.innerHTML = `
            ⚠️ Sold out for this colour, try
          <span id="alt-colour-1">
              <a class="alt-variant-url" href="${availableVariants[0].url}">${availableVariants[0].colour}</a>
          </span> ⚠️
      `;
          }
        }
      }
    } else {
      const soldOutText = document.querySelector(
        ".product__info-container-text-sold-out-text",
      );
      if (soldOutText) {
        soldOutText.innerHTML = "";
      }
    }
  }
  setUnavailable() {
    // Don't show unavailable/sold out if we're in SELECT A SIZE mode
    if (this.isInSelectSizeMode()) {
      devLog.log("🎯 SELECT A SIZE mode: Not showing unavailable state");
      this.toggleAddButton(false, "", false);
      return;
    }

    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const holdTightText = button.querySelector('[name="add"] .loading-text');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    //addButtonText.textContent = window.variantStrings.unavailable;
    holdTightText.classList.add("hidden");
    holdTightText.style.display = "none";
    addButtonText.classList.remove("hidden");
    addButtonText.style.display = "inline-block";
    addButtonText.textContent = "Out of Stock";
    if (price) price.classList.add("visibility-hidden");
  }
  loadInitialVariants() {
    // Load initial variant data into cache on first load
    try {
      const variantScript = this.querySelector(
        '[data-json-type="product-variants"]',
      );
      if (variantScript) {
        const variantData = JSON.parse(variantScript.textContent);

        if (variantData && variantData.length > 0) {
          window.variantCache.addVariants(variantData);
          devLog.log(
            `✅ Loaded ${variantData.length} initial variants into cache`,
          );

          // Mark initial page combination as fetched (after DOM is ready)
          setTimeout(() => {
            const selectedIds = this.getSelectedOptionValueIds();
            if (selectedIds.length > 0) {
              window.variantCache.markCombination(selectedIds);
              devLog.log(
                "✅ Initial combination marked as cached:",
                selectedIds,
              );
            }
          }, 100);
        }
      }
    } catch (error) {
      console.error("❌ Error loading initial variants:", error);
    }
  }

  getVariantData() {
    // Use cached data if available
    if (window.variantCache && window.variantCache.variants.size > 0) {
      const cachedVariants = window.variantCache.getAllVariants();
      devLog.log(
        `💾 Using cached variant data (${cachedVariants.length} variants)`,
      );
      return cachedVariants;
    }

    // Fallback: parse fresh from DOM
    const variantScript = this.querySelector(
      '[data-json-type="product-variants"]',
    );
    if (variantScript) {
      this.variantData = JSON.parse(variantScript.textContent);
      devLog.log(
        "🔄 Loaded variant data from DOM:",
        this.variantData.length,
        "variants",
      );
    } else {
      console.warn("⚠️ No variant script found in DOM");
    }
    return this.variantData || [];
  }

  forceRefreshVariantData() {
    devLog.log("🔄 Force refreshing variant data");
    this.variantData = null;
    return this.getVariantData();
  }

  displaySelectSizeText() {
    const selectSizeText = document.querySelector(
      ".product-detail__size-select-btn",
    );
    const sizeInputs = document.querySelectorAll(
      'input[type="radio"][name="Size"]',
    );
    const realAddToCartButton = document.querySelector(".product-form__submit");
    if (selectSizeText && sizeInputs.length > 0) {
      // Store the original selected size
      const trueSize = selectSizeText.textContent;
      selectSizeText.setAttribute("data-original-size", trueSize);
      selectSizeText.textContent = "SELECT A SIZE";

      // Set SELECT A SIZE mode flag
      this.isSelectSizeMode = true;

      // Uncheck all radio inputs initially
      sizeInputs.forEach((input) => {
        input.checked = false;
      });

      devLog.log("✅ Unchecked all size radios - SELECT A SIZE mode active");

      if (realAddToCartButton) {
        realAddToCartButton.style.display = "none";

        // Create and insert fake button
        const fakeButton = document.createElement("button");
        fakeButton.className =
          realAddToCartButton.className + " fake-add-to-cart";
        fakeButton.innerHTML = realAddToCartButton.innerHTML;
        realAddToCartButton.parentNode.insertBefore(
          fakeButton,
          realAddToCartButton,
        );

        // Add click handler to fake button
        fakeButton.addEventListener("click", (e) => {
          e.preventDefault();
          this.handleErrorMessage("Please select a size to add to cart");
          selectSizeText.classList.add("error");

          // Get header offset and scroll
          const scrollOffset = this.getHeaderOffset();
          const sizeSelectPosition =
            selectSizeText.getBoundingClientRect().top +
            window.pageYOffset -
            scrollOffset;

          // Smooth scroll to the size selector
          window.scrollTo({
            top: sizeSelectPosition,
            behavior: "smooth",
          });
        });

        // Add change handler to size inputs
        sizeInputs.forEach((input) => {
          input.addEventListener("change", () => {
            // Turn OFF SELECT A SIZE mode when user selects a size
            this.isSelectSizeMode = false;
            devLog.log("✅ Size selected - SELECT A SIZE mode deactivated");

            fakeButton.style.display = "none";
            realAddToCartButton.style.display = "";
            this.removeErrorMessage();
            selectSizeText.classList.remove("error");
          });
        });
      }
    }

    const existingTags = document.querySelectorAll(".urgency-tag");
    existingTags.forEach((tag) => tag.remove());
  }

  // Move getHeaderOffset inside the class as a method
  getHeaderOffset() {
    try {
      const header = document.querySelector(".header");
      const announcementBar = document.querySelector(".announcement-bar");
      let offset = 0;

      if (header) {
        offset += header.offsetHeight;
      }

      if (
        announcementBar &&
        window.getComputedStyle(announcementBar).display !== "none"
      ) {
        offset += announcementBar.offsetHeight;
      }

      // Add extra padding for better visual spacing
      offset += window.innerWidth <= 768 ? 20 : 50;

      return offset;
    } catch (error) {
      console.error("Error calculating header offset:", error);
      return window.innerWidth <= 768 ? 70 : 100; // Fallback offset
    }
  }

  handleErrorMessage(message) {
    const errorMessageWrapper = document.querySelector(
      ".product-form__error-message-size-wrapper",
    );
    if (!errorMessageWrapper) return;

    const errorMessage = errorMessageWrapper.querySelector(
      ".product-form__error-message-size",
    );

    errorMessageWrapper.toggleAttribute("hidden", !message);
    if (errorMessage) {
      errorMessage.textContent = message;
    }
  }

  removeErrorMessage() {
    const errorMessageWrapper = document.querySelector(
      ".product-form__error-message-size-wrapper",
    );
    if (!errorMessageWrapper) return;

    errorMessageWrapper.setAttribute("hidden", "");
  }

  getSelectedOptionValueIds() {
    devLog.log("🔍 Getting selected option value IDs");
    const checkedInputs = this.querySelectorAll(
      'input[type="radio"]:checked[data-option-value-id]',
    );
    const optionValueIds = Array.from(checkedInputs).map(
      (input) => input.dataset.optionValueId,
    );
    devLog.log("📋 Selected option value IDs:", optionValueIds);
    return optionValueIds;
  }

  getCacheStatus() {
    if (!window.variantCache) return null;
    return {
      totalVariants: window.variantCache.variants.size,
      cachedCombinations: window.variantCache.optionCombinations.size,
      variants: window.variantCache.getAllVariants(),
    };
  }

  updatePriceAndAvailabilityFromVariant() {
    if (!this.currentVariant) return;

    console.time("⚡ updatePriceAndAvailability (NO API CALL)");
    devLog.log(
      "⚡ Updating price/availability from variant data (NO API CALL)",
    );

    // Update price directly from variant data
    const priceElement = document.querySelector(
      `#price-${this.dataset.section}`,
    );
    if (priceElement && this.currentVariant.price !== undefined) {
      const price = this.formatMoney(this.currentVariant.price);
      const compareAtPrice = this.currentVariant.compare_at_price;

      // Update price display
      const priceRegular = priceElement.querySelector(".price__regular .price-item--regular");
      if (priceRegular) {
        priceRegular.textContent = price;
      }

      // Update compare at price if exists
      if (compareAtPrice && compareAtPrice > this.currentVariant.price) {
        const priceSale = priceElement.querySelector(".price-item--sale");
        if (priceSale) priceSale.textContent = price;

        const priceCompare = priceElement.querySelector(".price__sale .price-item--regular");
        if (priceCompare)
          priceCompare.textContent = this.formatMoney(compareAtPrice);

        priceElement.classList.add("price--on-sale");
      } else {
        priceElement.classList.remove("price--on-sale");
      }
    }

    // Update button availability
    const available = this.currentVariant.available;
    const inventoryQuantity = this.currentVariant.inventory_quantity || 0;
    const inventoryPolicy = this.currentVariant.inventory_policy || "";
    const continueSellWhenOutOfStock = inventoryPolicy.includes("continue");
    const showPreOrder =
      this.currentVariant.metafields?.show_preorder === "true" ||
      this.currentVariant.metafields?.show_preorder === true;

    devLog.log("🔍 Current variant availability check:");
    devLog.log("   - Variant ID:", this.currentVariant.id);
    devLog.log("   - Variant title:", this.currentVariant.title);
    devLog.log("   - Available:", this.currentVariant.available);
    devLog.log("   - Inventory quantity:", inventoryQuantity);
    devLog.log("   - Inventory policy:", inventoryPolicy);
    devLog.log(
      "   - Continue sell when out of stock:",
      continueSellWhenOutOfStock,
    );
    devLog.log("   - Show preorder:", showPreOrder);
    devLog.log("   - Raw variant data:", this.currentVariant);

    // Check if this is a pre-order scenario
    // Pre-order requires: showPreOrder = true, inventory < 1, AND continueSellWhenOutOfStock = true
    // NOTE: Check pre-order FIRST because continueSellWhenOutOfStock makes variant available=true even with 0 inventory
    const isPreOrder =
      showPreOrder && inventoryQuantity < 1 && continueSellWhenOutOfStock;

    // Hide/show Shopify payment button based on pre-order status
    // Target payment button within the product form for this section
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const paymentButton = productForm
      ? productForm.querySelector(".shopify-payment-button")
      : document.querySelector(".shopify-payment-button");

    if (isPreOrder) {
      // Hide payment button for pre-orders
      if (paymentButton) {
        paymentButton.style.display = "none";
        devLog.log("🚫 Hiding Shopify payment button for pre-order");
      }
    } else {
      // Show payment button for regular variants
      if (paymentButton) {
        paymentButton.style.display = "";
        devLog.log("✅ Showing Shopify payment button for regular variant");
      }
    }

    // Use toggleAddButton to manage button state
    if (isPreOrder) {
      devLog.log(
        "📦 Variant is PRE-ORDER, enabling button with Pre-order text",
      );
      devLog.log("📦 Pre-order conditions:", {
        showPreOrder,
        inventoryQuantity,
        continueSellWhenOutOfStock,
        isPreOrder,
      });
      // Enable button but show "Pre-order" text instead of "Add to Cart"
      // Force update by ensuring loading text is hidden and main text is visible
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
      if (productForm) {
        const addButton = productForm.querySelector('[name="add"]');
        if (addButton) {
          const loadingText = addButton.querySelector(".loading-text");
          const mainTextSpan = addButton.querySelector(
            "span:not(.loading-text)",
          );

          // Ensure loading text is hidden
          if (loadingText) {
            loadingText.style.display = "none";
            loadingText.classList.add("hidden");
          }

          // Ensure main text span is visible and set to "Pre-order"
          if (mainTextSpan) {
            mainTextSpan.style.display = "inline-block";
            mainTextSpan.classList.remove("hidden");
            mainTextSpan.textContent = "Pre-order";
            devLog.log("📦 Directly set button text to 'Pre-order'");
          }

          // Enable the button
          addButton.removeAttribute("disabled");
        }
      }
      // Also call toggleAddButton to ensure consistency
      this.toggleAddButton(false, "Pre-order", false);
    } else if (available) {
      devLog.log("✅ Variant IS available, enabling button");
      this.toggleAddButton(false, "", false);
    } else {
      // Don't show sold out if we're in SELECT A SIZE mode
      if (this.isInSelectSizeMode()) {
        devLog.log("🎯 SELECT A SIZE mode: Not showing sold out");
        this.toggleAddButton(false, "", false);
      } else {
        devLog.log("❌ Variant NOT available (sold out)");
        this.toggleAddButton(
          true,
          window.variantStrings?.soldOut || "Sold out",
          false,
        );
      }
    }

    console.timeEnd("⚡ updatePriceAndAvailability (NO API CALL)");
    devLog.log("✅ Price/availability updated instantly - NO API CALL!");

    // Update urgency tags and notify me options
    this.updateUrgencyAndNotifications();
  }

  updateUrgencyAndNotifications() {
    if (!this.currentVariant || !this.currentVariant.id) return;

    // Use variant data directly (no need for vars object!)
    const inventoryQuantity = this.currentVariant.inventory_quantity || 0;
    const inventoryPolicy = this.currentVariant.inventory_policy || "";
    const continueSellWhenOutOfStock = inventoryPolicy.includes("continue");
    devLog.log(
      "this.currentVariant.metafields ",
      this.currentVariant.metafields,
    );
    devLog.log(
      "this.currentVariant.metafields?.show_preorder ",
      this.currentVariant.metafields?.show_preorder,
    );
    // Get metafields from variant if available
    const showNotifyMe =
      this.currentVariant.metafields?.show_notify_me === "true" ||
      this.currentVariant.metafields?.show_notify_me === true;
    const showPreOrder =
      this.currentVariant.metafields?.show_preorder === "true" ||
      this.currentVariant.metafields?.show_preorder === true;
    // Get notify text - check both possible metafield names
    const notifyMeText =
      this.currentVariant.metafields?.preorder_notify_text ||
      this.currentVariant.metafields?.preorder_notify_me_text ||
      "";
    devLog.log("🔍 notifyMeText:", notifyMeText);
    devLog.log("🔍 metafields object:", this.currentVariant.metafields);
    devLog.log(
      "🔔 Updating notifications for variant:",
      this.currentVariant.id,
    );
    devLog.log("   - Inventory:", inventoryQuantity);
    devLog.log("   - Inventory policy:", inventoryPolicy);
    devLog.log("   - Continue selling:", continueSellWhenOutOfStock);
    devLog.log("   - Show notify me:", showNotifyMe);
    devLog.log("   - Show preorder:", showPreOrder);

    // Update urgency tags
    this.updateUrgencyTag(inventoryQuantity);

    // Update notify me / preorder options
    const productThumbnailSlider = document.querySelector(
      ".product--thumbnail_slider",
    );

    if (inventoryQuantity < 1) {
      if (showNotifyMe) {
        document.body.classList.add("show-notify-me");
        // Update notify button with current variant ID
        const notifyBtn = document.querySelector('.notify-me-btn');
        if (notifyBtn) {
          notifyBtn.setAttribute('data-variant-id', this.currentVariant.id);
          notifyBtn.setAttribute('onclick', "NalaBIS.open('" + this.currentVariant.id + "')");
        }
      }

      // Don't show sold out if we're in SELECT A SIZE mode
      if (this.isInSelectSizeMode()) {
        if (productThumbnailSlider) {
          productThumbnailSlider.classList.remove("sold-out");
        }
        devLog.log("🎯 SELECT A SIZE mode: Not showing sold-out class");
      } else {
        // Handle pre-order state - if pre-order is enabled, don't show as sold out
        if (showPreOrder) {
          if (productThumbnailSlider) {
            productThumbnailSlider.classList.remove("sold-out");
          }
        } else {
          // Not a pre-order, show as sold out
          if (productThumbnailSlider) {
            productThumbnailSlider.classList.add("sold-out");
          }
        }
      }

      // Update notify me text - always check and update, even if empty
      const notifyItem = document.querySelector(".hidden-notify-item");
      if (notifyItem) {
        if (notifyMeText && notifyMeText.trim() !== "") {
          notifyItem.innerHTML = notifyMeText;
          notifyItem.style.display = "";
          document.body.classList.remove("hidden-hidden-notify-item");
          devLog.log("✅ Showing notify me text:", notifyMeText);
        } else {
          notifyItem.innerHTML = "";
          notifyItem.style.display = "none";
          document.body.classList.add("hidden-hidden-notify-item");
          devLog.log("ℹ️ Hiding notify me text (empty or not set)");
        }
      }
    } else {
      // Inventory >= 1 - hide notify item and notify me button
      document.body.classList.remove("show-notify-me");
      const notifyItem = document.querySelector(".hidden-notify-item");
      if (notifyItem) {
        notifyItem.innerHTML = "";
        notifyItem.style.display = "none";
      }
      document.body.classList.add("hidden-hidden-notify-item");
      if (productThumbnailSlider) {
        productThumbnailSlider.classList.remove("sold-out");
      }
    }
  }

  updateUrgencyTag(inventoryQuantity) {
    const selectSizeText = document.querySelector(
      ".product-detail__size-select-btn",
    );

    // Don't show if "select a size" is displayed
    if (
      selectSizeText &&
      selectSizeText.innerHTML.toLowerCase().includes("select a size")
    ) {
      return;
    }

    const sizeDropdown = document.querySelector(".size-dropdown");

    // Remove existing urgency tags
    const existingTags = document.querySelectorAll(".urgency-tag");
    existingTags.forEach((tag) => tag.remove());

    if (!sizeDropdown) return;

    const container = document.createElement("div");

    if (inventoryQuantity < 10 && inventoryQuantity > 0) {
      // Low stock warning
      container.innerHTML =
        '<div class="urgency-tag tag-limited-availability">🔥 Limited Availability - Less than 5 units left!</div>';
      sizeDropdown.appendChild(container);
      devLog.log("🔥 Urgency tag: Limited availability");
    } else if (inventoryQuantity > 0) {
      // Check if in selling-fast collection
      const bestSellerTag = document.querySelector(
        '[data-collection-handle="selling-fast"]',
      );
      if (bestSellerTag) {
        container.innerHTML =
          '<div class="urgency-tag tag-selling-fast">🔥 Selling Fast!</div>';
        sizeDropdown.appendChild(container);
        devLog.log("🔥 Urgency tag: Selling fast");
      }
    }
  }

  formatMoney(cents) {
    if (typeof cents === "string") cents = parseInt(cents);
    const dollars = (cents / 100).toFixed(2);
    return window.Shopify?.formatMoney
      ? window.Shopify.formatMoney(
          cents,
          window.theme?.moneyFormat || "${{amount}}",
        )
      : `$${dollars}`;
  }

  autoPrefetchFromConfig() {
    devLog.log("🚀 Auto-prefetch: Checking for prefetch configuration");

    try {
      // Load config if not already loaded
      if (!this.config) {
        const prefetchConfigScript = this.querySelector(
          '[data-json-type="prefetch-config"]',
        );

        if (!prefetchConfigScript) {
          devLog.log("ℹ️ No prefetch config found");
          return;
        }

        this.config = JSON.parse(prefetchConfigScript.textContent);
      }

      if (!this.config.enabled) {
        devLog.log("ℹ️ Prefetch disabled in config");
        return;
      }

      devLog.log("✅ Prefetch config loaded:", this.config);

      // Get the size and color options
      const sizeOption =
        this.config.optionValueIds.size || this.config.optionValueIds.Size;
      const colorOption =
        this.config.optionValueIds.color ||
        this.config.optionValueIds.Colour ||
        this.config.optionValueIds.colour;

      if (!sizeOption || !colorOption) {
        devLog.log("⚠️ Size or Color option not found in config");
        return;
      }

      // Find currently selected color
      const selectedColor = colorOption.find((opt) => {
        const radioInput = this.querySelector(
          `input[type="radio"][data-option-value-id="${opt.id}"]:checked`,
        );
        return radioInput !== null;
      });

      if (!selectedColor) {
        devLog.log("⚠️ No selected color found");
        return;
      }

      devLog.log(
        `🎨 Current color: ${selectedColor.name} (ID: ${selectedColor.id})`,
      );

      // Prefetch variants for each preferred size index
      const prefetchPromises = this.config.preferredSizeIndices.map(
        (sizeIndex, arrayIndex) => {
          if (sizeIndex >= sizeOption.length) {
            devLog.log(
              `⚠️ Size index ${sizeIndex} out of range (max: ${
                sizeOption.length - 1
              }); using middle index instead`,
            );
            sizeIndex = Math.floor(sizeOption.length / 2);
            // Update the config array with the corrected index
            this.config.preferredSizeIndices[arrayIndex] = sizeIndex;
          }

          const preferredSize = sizeOption[sizeIndex];
          const optionValueIds = [selectedColor.id, preferredSize.id];

          // Check if already cached
          if (window.variantCache.hasCombination(optionValueIds)) {
            devLog.log(
              `✅ Size index ${sizeIndex} (${preferredSize.name}) already cached`,
            );
            return Promise.resolve();
          }

          devLog.log(
            `🌐 Prefetching size index ${sizeIndex}: ${preferredSize.name}`,
          );

          const params = `&option_values=${optionValueIds.join(",")}`;
          const fetchUrl = `${this.config.productUrl}?section_id=${this.config.sectionId}${params}`;

          return fetch(fetchUrl)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html",
              );
              const newVariantScript = html.querySelector(
                '[data-json-type="product-variants"]',
              );

              if (newVariantScript) {
                const newVariants = JSON.parse(newVariantScript.textContent);
                if (newVariants && newVariants.length > 0) {
                  window.variantCache.addVariants(newVariants);
                  window.variantCache.markCombination(optionValueIds);
                  devLog.log(
                    `✅ Prefetched ${newVariants.length} variants for size ${preferredSize.name}`,
                  );
                }
              }
            })
            .catch((error) => {
              devLog.log(
                `⚠️ Prefetch failed for size ${preferredSize.name}:`,
                error,
              );
            });
        },
      );

      // Wait for all prefetches to complete, then rebuild sticky dropdown
      Promise.all(prefetchPromises).then(() => {
        devLog.log("✅ All prefetches complete");
        this.rebuildStickyVariantOptions();
      });
    } catch (error) {
      devLog.log("⚠️ Error in auto-prefetch (non-critical):", error);
    }
  }

  fetchSectionWithOptions(optionValueIds) {
    // ✅ CACHE CHECK: Skip fetch if we already have this combination
    if (window.variantCache.hasCombination(optionValueIds)) {
      devLog.log("💾 Combination already in cache, using cached data");

      // Try to find variant in cache
      const cachedVariant = window.variantCache.getVariant(
        this.options[0],
        this.options[1],
      );
      if (cachedVariant) {
        devLog.log("✅ Found variant in cache:", cachedVariant.title);
        this.currentVariant = cachedVariant;

        // Update UI with cached data (no fetch needed!)
        this.updateVariantUrl();
        // 🚀 FAST PATH: Update price/availability from variant data (NO API CALL!)
        this.updatePriceAndAvailabilityFromVariant(); // This calls updateUrgencyAndNotifications()
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.updateShareUrl();
        this.updateStickyVariantSelector();
        this.verifyFormState();

        console.timeEnd("totalTime");
        devLog.log("⚡ Used cache - NO API CALL MADE!");
        return;
      }
    }

    devLog.log(
      "🌐 Cache miss - Fetching NEW section with option values:",
      optionValueIds,
    );

    // Build fetch URL with option_values parameter
    const params =
      optionValueIds.length > 0
        ? `&option_values=${optionValueIds.join(",")}`
        : "";

    const sectionId = this.dataset.section;
    const productUrl = this.dataset.url;

    const fetchUrl = `${productUrl}?section_id=${sectionId}${params}`;
    devLog.log("🌐 Fetch URL (variants only):", fetchUrl);
    fetch(fetchUrl)
      .then((response) => {
        devLog.log("📡 Section fetch response:", response.status);
        return response.text();
      })
      .then((responseText) => {
        devLog.log("📄 Section fetched, parsing HTML");
        const html = new DOMParser().parseFromString(responseText, "text/html");

        // Extract and cache new variant data
        const newVariantScript = html.querySelector(
          '[data-json-type="product-variants"]',
        );
        if (newVariantScript) {
          const newVariants = JSON.parse(newVariantScript.textContent);

          // Add new variants to cache
          if (newVariants && newVariants.length > 0) {
            window.variantCache.addVariants(newVariants);
            window.variantCache.markCombination(optionValueIds);
            devLog.log("✅ Added", newVariants.length, "new variants to cache");

            // Rebuild sticky dropdown options with new variants
            this.rebuildStickyVariantOptions();
          }

          // Update DOM JSON (optional, for compatibility)
          const currentVariantScript = document.querySelector(
            '[data-json-type="product-variants"]',
          );
          if (currentVariantScript) {
            currentVariantScript.textContent = newVariantScript.textContent;
            devLog.log("✅ Variant JSON in DOM updated");
          }

          // Clear instance cache to force using global cache
          this.variantData = null;
        }

        // Update option values JSON
        const newOptionValuesScript = html.querySelector(
          '[data-json-type="product-option-values"]',
        );
        if (newOptionValuesScript) {
          const currentOptionValuesScript = document.querySelector(
            '[data-json-type="product-option-values"]',
          );
          if (currentOptionValuesScript) {
            currentOptionValuesScript.textContent =
              newOptionValuesScript.textContent;
            devLog.log("✅ Option values JSON updated");
          }
        }

        // Now retry finding the variant
        this.updateMasterId();
        devLog.log("🎯 Current variant after refetch:", this.currentVariant);

        if (!this.currentVariant) {
          console.warn("⚠️ Still no current variant after refetch");
          this.setUnavailable();
        } else {
          devLog.log("✅ Variant found after refetch, updating UI");
          this.updateVariantUrl();
          // 🚀 FAST PATH: Update price/availability from variant data (already in JSON!)
          this.updatePriceAndAvailabilityFromVariant(); // This calls updateUrgencyAndNotifications()
          this.updateMedia();
          this.updateURL();
          this.updateVariantInput();
          this.updateShareUrl();
          this.updateStickyVariantSelector();
          this.verifyFormState();
        }

        console.timeEnd("totalTime");
      })
      .catch((error) => {
        console.error("❌ Error fetching section:", error);
        // Fallback to unavailable state
        this.setUnavailable();
      });
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll("input"));
      const checkedRadio = inputs.find((radio) => radio.checked);
      if (checkedRadio) {
        return checkedRadio.value;
      } else if (inputs.length > 0) {
        // Use the persistent flag to determine SELECT A SIZE mode
        // This flag persists across color changes, preventing radios from being checked
        const isSelectSizeMode = this.isSelectSizeMode === true;

        // Default to a better size option (typically 3rd option: M or 10DD)
        // This helps show more available colors when browsing
        // Load config if not already loaded
        if (!this.config) {
          const prefetchConfigScript = this.querySelector(
            '[data-json-type="prefetch-config"]',
          );

          if (!prefetchConfigScript) {
            devLog.log("ℹ️ No prefetch config found");
            return;
          }

          this.config = JSON.parse(prefetchConfigScript.textContent);
        }

        // Get the size options from config (same as in prefetch function)
        const sizeOption =
          this.config.optionValueIds.size || this.config.optionValueIds.Size;

        if (!sizeOption) {
          devLog.log("⚠️ Size option not found in config");
          return;
        }

        let preferredSizeIndex = this.config.preferredSizeIndices[0];

        // Check if preferred index is out of range for sizeOption and correct it
        if (preferredSizeIndex >= sizeOption.length) {
          devLog.log(
            `⚠️ Preferred size index ${preferredSizeIndex} out of range (max: ${
              sizeOption.length - 1
            }); using middle index instead`,
          );
          preferredSizeIndex = Math.floor(sizeOption.length / 2);
          // Update the config array with the corrected index
          this.config.preferredSizeIndices[0] = preferredSizeIndex;
        }

        // Get the preferred size option from config
        const preferredSize = sizeOption[preferredSizeIndex];

        // Find the corresponding input element by matching data-option-value-id
        let indexToSelect = inputs.findIndex(
          (input) =>
            input.dataset.optionValueId === preferredSize.id.toString(),
        );

        // If not found by id, fallback to index-based lookup (for backwards compatibility)
        if (indexToSelect === -1) {
          devLog.log(
            `⚠️ Could not find input for size ${preferredSize.name} (ID: ${preferredSize.id}), using index ${preferredSizeIndex}`,
          );
          indexToSelect = preferredSizeIndex;
        }

        // Check if the found index is out of range for inputs array
        if (indexToSelect >= inputs.length) {
          devLog.log(
            `⚠️ Input index ${indexToSelect} out of range (max: ${
              inputs.length - 1
            }); using middle index instead`,
          );
          indexToSelect = Math.floor(inputs.length / 2);
        }

        // Check if preferred option exists and is not disabled
        if (inputs[indexToSelect]?.disabled) {
          // Fallback: find first non-disabled option
          const firstAvailable = inputs.findIndex((input) => !input.disabled);
          indexToSelect = firstAvailable !== -1 ? firstAvailable : 0;
        }

        if (isSelectSizeMode) {
          devLog.log(
            `🎯 Preview mode: Using size index ${indexToSelect} (${inputs[indexToSelect]?.value}) without checking radio`,
          );
        } else {
          devLog.log(
            `🎯 Auto-selecting size option at index ${indexToSelect} (${inputs[indexToSelect]?.value})`,
          );
        }

        // Only check the radio button if NOT in "SELECT A SIZE" mode
        // This prevents the bug where clicking the pre-selected option doesn't trigger change
        if (!isSelectSizeMode) {
          inputs[indexToSelect].checked = true;
        }

        return inputs[indexToSelect].value;
      }
    });
    devLog.log("🔍 variant-radios this.options:", this.options);
  }
}

customElements.define("variant-radios", VariantRadios);

function renderDetails() {
  const soldOut = document.querySelector(".product__sold-out");
  const isBundle = !!document.querySelectorAll('[data-bundle="true"]').length;

  fetch(window.location.href)
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, "text/html");

      // Check if we're in SELECT A SIZE mode
      const variantSelector = document.querySelector(
        "variant-selects, variant-radios",
      );
      const isSelectSizeMode = variantSelector?.isInSelectSizeMode
        ? variantSelector.isInSelectSizeMode()
        : false;

      if (doc.querySelector("[data-available]").dataset.available == "true") {
        soldOut.classList.remove("sold-out");
      } else {
        // Don't show sold out if we're in SELECT A SIZE mode or if it's a bundle
        if (!isBundle && !isSelectSizeMode) {
          soldOut.classList.add("sold-out");
        } else {
          soldOut.classList.remove("sold-out");
        }
      }
    })
    .catch(function (err) {
      console.warn("Something went wrong.", err);
    });
}
// changeVariants()
function openSize() {
  document.querySelector(".size-guide").style.display = "block";
  document.body.style.overflow = "hidden";
}
